import LTR from "@brand-icons/ploom/ui-check-circle/ui-check-circle-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiCheckCircleIcon = iconFactory("UiCheckCircleIcon", LTR);
